<div class="upper-bar">
  <a routerLink="/" class="logo-link">
    <img class="logo" src="./assets/ui/svg/multi-color/sharemedix-logo.svg">
  </a>
  <div class="bluegdpr-info-dropdown">
    <div [matMenuTriggerFor]="moreInfo" class="bluegdpr-upper">
      <img src="./assets/ui/svg/white/person-icon.svg">
      <span>Hello {{name}}!</span>
      <img src="./assets/ui/svg/white/arrow-dropdown.svg" class="dropdownarrow">
    </div>
    <mat-menu xPosition="before" #moreInfo="matMenu">
      <div class="more-info">
        <div class="more-info-image">
          <img src="./assets/ui/svg/blue/icon-person.svg">
        </div>
        <div class="more-info-label">
          <span class="more-info-name">{{name}}</span>
          <span>{{email}}</span>
        </div>
      </div>
      <mat-divider></mat-divider>
      <button [routerLink]="['/change-password']" mat-menu-item class="shadow-none">Change password</button>
<!--      <button [routerLink]="['/settings']" mat-menu-item class="shadow-none">Settings</button>-->
      <a href="mailto:contact@theblue.ai" mat-menu-item class="shadow-none grey-link">Support</a>
      <button (click)="goToLogin()" mat-menu-item>Logout</button>
    </mat-menu>
  </div>
</div>
<div class="bg-network"></div>
<div class="main-part">
  <div class="left-bar" [@expansionTrigger]="isOpenNavbar">
    <nav class="main-bar">
      <ul>
        <li>
          <a class="hamburger-menu" (click)="toggleMenu()">
            <img src="./assets/ui/svg/grey/icon-menu.svg">
          </a>
        </li>
        <li>
          <a [routerLink]="['/']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" >
            <img src="{{'./assets/ui/svg/grey/icon-upload.svg'}}">
            <div [className]="'normal'"  [@colExpansion]="isOpenNavbar">Upload</div>
          </a>
        </li>
        <li>
          <a [routerLink]="['/browse']" routerLinkActive="active">
            <img src="{{'./assets/ui/svg/grey/icon-browse.svg'}}">
            <div [className]="'normal'" [@colExpansion]="isOpenNavbar">My Files</div>
          </a>
        </li>
        <li>
          <a [routerLink]="['/transfers']" routerLinkActive="active">
            <img src="{{'./assets/ui/svg/grey/icon-transfers.svg'}}">
            <div [className]="'normal'" [@colExpansion]="isOpenNavbar">Transfers</div>
          </a>
        </li>
        <li>
          <a [routerLink]="['/requests']" routerLinkActive="active">
            <img src="{{'./assets/ui/svg/grey/icon-requests.svg'}}">
            <div [className]="'normal'" [@colExpansion]="isOpenNavbar">Requests</div>
          </a>
        </li>
      </ul>
    </nav>
    <div class="empty-area"></div>
    <div class="copyright">
      <div class="copyright-divider"></div>
      <span *ngIf="isOpenNavbar==='on'" @swipeRight>Copyright ©{{currentYear}} theBlue.ai GmbH</span>
      <span *ngIf="isOpenNavbar==='off'" @swipeRight>©2022</span>
    </div>

  </div>
  <div class="right-bar" [@rightPanel]="isOpenNavbar">
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
